import { useRef, useEffect, DependencyList, EffectCallback } from 'react';

/**
 * A custom useEffect hook that skips the first render.
 * Useful for effects that should only run when dependencies change,
 * not on initial mount.
 */
const useUpdateEffect = (effect: EffectCallback, deps?: DependencyList) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useUpdateEffect;
